import React, { CSSProperties, forwardRef, PropsWithChildren } from 'react';

export type ScrollAreaColunaContainerProps = PropsWithChildren<{
  orientacao: 'vertical' | 'horizontal';
  $espacamentoItens?: 1 | 2 | 3 | 4 | 5 | 6;
  style?: CSSProperties;
  $mostrarThumbScroll?: boolean;
  onScroll?: React.UIEventHandler<HTMLDivElement>;
}>;

import * as S from './styles';

const ScrollAreaColunaContainer = forwardRef<
  HTMLDivElement,
  ScrollAreaColunaContainerProps
>((props, ref) => {
  const {
    orientacao,
    $espacamentoItens = 0,
    // $mostrarThumbScroll,
    style = {},
    onScroll = undefined,
  } = props;

  return (
    <S.ScrollAreaRoot style={style} type={'auto'}>
      <S.ScrollAreaViewport
        ref={ref}
        $orientacao={orientacao}
        onScroll={onScroll}
      >
        <S.ContainerConteudo
          $orientacao={orientacao}
          $espacamentoItens={$espacamentoItens}
        >
          {props.children}
        </S.ContainerConteudo>
      </S.ScrollAreaViewport>
      <S.ScrollAreaScrollbar $orientacao={orientacao}>
        <S.ScrollAreaThumb />
      </S.ScrollAreaScrollbar>
    </S.ScrollAreaRoot>
  );
});

ScrollAreaColunaContainer.displayName = 'ScrollAreaColunaContainer';

export default ScrollAreaColunaContainer;
